<template>
  <div class="store-event-shortcode">
    <div class="turnstile-container">
      <div v-if="hasLogo" class="logo-container">
        <img :src="getAssets.images.finish.logo" alt="logo" />
      </div>
      <div id="cf-turnstile" ref="turnstileWidget"></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'StoreEventShortcode',
  data() {
    return {
      turnstileSiteKey: process.env.VUE_APP_TURNSTILE_SITE_KEY,
      turnstileWidgetId: null
    }
  },
  computed: {
    ...mapGetters(['GET_ASSETS']),
    hasLogo() {
      return Boolean(this.getAssets.images?.finish?.logo)
    },
    getAssets() {
      return this.GET_ASSETS || {}
    },
    shortCode() {
      return this.$route.params.shortCode
    }
  },
  mounted() {
    this.loadTurnstile()
  },
  methods: {
    ...mapActions(['authenticateConsumerStoreEventShortCode']),
    loadTurnstile() {
      // Check if script is already loaded
      if (window.turnstile) {
        this.renderTurnstile()
        return
      }

      // Load Cloudflare Turnstile script
      const script = document.createElement('script')
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
      script.async = true
      script.defer = true
      script.onload = () => {
        this.renderTurnstile()
      }
      document.head.appendChild(script)
    },
    renderTurnstile() {
      if (window.turnstile && this.$refs.turnstileWidget) {
        this.turnstileWidgetId = window.turnstile.render(this.$refs.turnstileWidget, {
          sitekey: this.turnstileSiteKey,
          theme: 'light',
          callback: this.onTurnstileSuccess
        })
      }
    },
    async onTurnstileSuccess(token) {
      try {
        const response = await this.authenticateConsumerStoreEventShortCode({
          shortCode: this.shortCode,
          turnstileToken: token
        })
        // Navigate to store event page with eventId
        this.$router.push({
          name: 'store-event',
          params: { eventId: response.event._id }
        })
      } catch (error) {
        console.error('Failed to authenticate:', error)
        // Show error snackbar
        this.$snackbar({
          message: 'Ocorreu um erro. Tente novamente mais tarde',
          snackbarColor: 'error'
        })
        // Reset Turnstile widget on error
        if (this.turnstileWidgetId && window.turnstile) {
          window.turnstile.reset(this.turnstileWidgetId)
        }
        // Redirect to home
        this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>

<style scoped>
.store-event-shortcode {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
}

.turnstile-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
}

.logo-container {
  max-width: 140px;
  height: 140px;
  display: flex;
  align-items: center;
}

.logo-container img {
  display: block;
  width: 100%;
}
</style>
